module.exports = __webpack_public_path__ + "static/img/main2_5.bd7035f4.png";